(() => {
  if (window.nordicNavigationReady) return;
  window.nordicNavigationReady = true;
  const closeMenu = (details, returnFocus = false) => {
    details.open = false;
    if (returnFocus) details.querySelector('summary')?.focus();
  };
  document.addEventListener('toggle', (event) => {
    const current = event.target;
    if (!(current instanceof HTMLDetailsElement) || !current.matches('.nordic-disclosure') || !current.open) return;
    current.closest('[data-nordic-navigation]')?.querySelectorAll('.nordic-disclosure[open]').forEach((item) => {
      if (item !== current) closeMenu(item);
    });
  }, true);
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('[data-nordic-close]');
    if (button) closeMenu(button.closest('details'), true);
    const link = target.closest('.nordic-menu-panel a');
    if (link) closeMenu(link.closest('details'));
    document.querySelectorAll('.nordic-disclosure[open]').forEach((item) => {
      if (!target.closest('[data-nordic-navigation]')) closeMenu(item);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nordic-disclosure[open]').forEach((item) => closeMenu(item, true));
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.nordic-disclosure[open]').forEach((item) => {
      if (!item.closest('[data-nordic-navigation]')?.contains(event.target)) closeMenu(item);
    });
  });
})();
